<div [ngClass]="{'basket-page': isBasketPage }">
    <div class="orderline">
        <div *ngFor="let orderLine of packageOrderLines; let i = index" class="orderline-container">
            <div class="orderline__row removable" *ngFor="let item of orderLine.items; let j = index"
                [ngClass]="{ 'deleting': (pendingDeleteItem != null && pendingDeleteItem == orderLine.items[j]) }">
                <div class="orderline-container-small">
                    <div
                        class='orderline-container-icon orderline-container-icon-package orderline-container-icon-package--{{ ("global_package_primary_name_" + orderLine.name) | resource }}'>
                    </div>
                </div>

                <div class="orderline-container-info">
                    <div class="">
                        <div class="">
                            <div class="title">
                                {{ ("global_package_primary_name_" + orderLine.name) | resource }}
                            </div>
                        </div>

                        <div class="accordion">
                            <input type="checkbox" id="section-{{i}}-{{j}}" class="accordion__input">
                            <label for="section-{{i}}-{{j}}" class="accordion__label"
                                [ngClass]="{'accordion__label-button-show': showPackageDetails}">{{item.Shares.length}} enkeltlodder</label>
                            <div class="accordion__content" *ngIf="showPackageDetails">
                                <div class="removable orderline__ticketNr" *ngFor="let share of sortSharesByTicketNumberDesc(item.Shares)">
                                    Lodnr:
                                    {{ share.Ticket.TicketNumber }}{{ share.Name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="orderline-price">
                    {{ ((!showPerMonth && classCount === 6) ? orderLine.price.subscriptionSixMonths :
                    orderLine.price.subscriptionSingleMonth) / orderLine.items.length | money }}
                    {{ (!showPerMonth && classCount === 6) ? "/halvår" : "/md" }}
                </div>

                <div *ngIf="locked === false && !checkoutState && !isCheckout" class="remove"
                    (click)="openConfirmRemoveModal(true, orderLine.items[j])" tabindex="0"
                    (keypress)="$event.key === 'Enter' && openConfirmRemoveModal(true, orderLine.items[j])"></div>
            </div>

        </div>

        <div *ngFor="let orderLine of shareOrderLines; let i = index" class="orderline-container">
            <div class="orderline__row removable" *ngFor="let item of orderLine.items; let j = index"
                [ngClass]="{ 'deleting': (pendingDeleteItem != null && pendingDeleteItem == orderLine.items[j]) }">
                <!-- <div class="orderline__row"> -->
                <div
                    class='orderline-container-icon orderline-container-icon-ticket orderline-container-icon-ticket--{{ ("global_ticket_normalized_name_" + orderLine.items[0].share.Type.Size) | resource }}'>
                </div>
                <div class="orderline-container-info">
                    <div class="">
                        <div class="title">
                            {{ ("global_share_type_name_" + orderLine.name) | resource }}
                        </div>
                    </div>

                    <div class="removable orderline__ticketNr"
                        [ngClass]="{'deleting': (pendingDeleteItem == item.share) }">
                        Lodnr:
                        {{ item.share.Ticket.TicketNumber }}{{ item.share.Name }}
                    </div>
                </div>

                <div class="orderline-price">
                    {{ ((!showPerMonth && classCount === 6) ? orderLine.price.subscriptionSixMonths :
                    orderLine.price.subscriptionSingleMonth ) / orderLine.items.length | money }}
                    {{ (!showPerMonth && classCount === 6) ? "/halvår" : "/md" }}
                </div>

                <div *ngIf="item && !checkoutState && !isCheckout" class="remove"
                    (click)="openConfirmRemoveModal(false, orderLine.items[j].share)" tabindex="0"
                    (keypress)="$event.key === 'Enter'&& openConfirmRemoveModal(false, orderLine.items[j].share)"></div>
            </div>
        </div>
        <div *ngFor="let fee of fees; let i = index" class="orderline-container">
            <div *ngIf="!isBasketPage && showFees" class="orderline__row removable">
                <div class="orderline-fee-icon">
                </div>
                <div class="orderline-container-info">
                    <div class="">
                        <div class="fee title">
                            Betalingsgebyr
                        </div>
                    </div>
                </div>
                <div class="orderline-price">
                    {{fee.value | money}}
                </div>
            </div>
        </div>
        <div *ngIf="isBasketPage && showAddMore" class="orderline-container mt-2">
            <div class="orderline__row border-0">
                <div class="orderline-container-info">
                    <div class="">
                        <div class="title">
                            Forøg din chance?
                        </div>
                    </div>

                    <div class="removable orderline__ticketNr">
                        Du kan altid tilføje flere lodder
                    </div>
                </div>

                <div class="orderline-price">
                    <button (click)="onAddMoreClick()"
                        class="cta cta--primary">Tilføj flere <span
                            class="orderline-add-button-icon"> </span></button>
                </div>
            </div>
        </div>

        <div class="price">
            <div *ngIf="isBsAppActive" class="fees-text">
                <p>(+tilkøb af {{ drawDateFirst | date : "MMMM" }})</p>
            </div>

            <div *ngIf="classCount > 1 && priceChangeInEffect" class="pricing-update-link">
                <a (click)="onPricingDetailsClick()" [ngClass]="{ 'disabled': pricingUpdateExpanded }">Sådan beregnes
                    prisen</a>
            </div>
        </div>
        <ng-container *ngIf="showWinRates">
            <div class="winrates" *ngIf="!isBasketPage">
                <div class="winrate" [ngClass]="{ 'winrate--checkout': navigateCheckout }">
                    <div class="winrate-cell">
                        <div class="caption">
                            Årlig vinderchance
                        </div>
                        <div class="number" [innerHtml]="winChance | percent : null : 'en'"></div>
                    </div>
                </div>
                <div class="winrate" [ngClass]="{ 'winrate--checkout': navigateCheckout }">
                    <div class="winrate-cell">
                        <div class="caption">
                            Min - max gevinst

                        </div>
                        <div class="winrate-price">
                            <div class="number" [innerHtml]="minPrize | money"></div> - <div class="number"
                                [innerHtml]="topPrize | money"></div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <app-confirm-remove-modal #confirmRemoveModal
            (onConfirmRemoval)="handleConfirmedRemoval($event)"></app-confirm-remove-modal>

    </div>
</div>
